// no baseURI

// object to store loaded and loading chunks
// undefined = chunk not loaded, null = chunk preloaded/prefetched
// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
var installedChunks = __webpack_require__.hmrS_jsonp = __webpack_require__.hmrS_jsonp || {
	"main": 0
};

__webpack_require__.f.j = (chunkId, promises) => {
		// JSONP chunk loading for javascript
		var installedChunkData = __webpack_require__.o(installedChunks, chunkId) ? installedChunks[chunkId] : undefined;
		if(installedChunkData !== 0) { // 0 means "already installed".

			// a Promise means "currently loading".
			if(installedChunkData) {
				promises.push(installedChunkData[2]);
			} else {
				if(true) { // all chunks have JS
					// setup Promise in chunk cache
					var promise = new Promise((resolve, reject) => (installedChunkData = installedChunks[chunkId] = [resolve, reject]));
					promises.push(installedChunkData[2] = promise);

					// start chunk loading
					var url = __webpack_require__.p + __webpack_require__.u(chunkId);
					// create error before stack unwound to get useful stacktrace later
					var error = new Error();
					var loadingEnded = (event) => {
						if(__webpack_require__.o(installedChunks, chunkId)) {
							installedChunkData = installedChunks[chunkId];
							if(installedChunkData !== 0) installedChunks[chunkId] = undefined;
							if(installedChunkData) {
								var errorType = event && (event.type === 'load' ? 'missing' : event.type);
								var realSrc = event && event.target && event.target.src;
								error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
								error.name = 'ChunkLoadError';
								error.type = errorType;
								error.request = realSrc;
								installedChunkData[1](error);
							}
						}
					};
					__webpack_require__.l(url, loadingEnded, "chunk-" + chunkId, chunkId);
				}
			}
		}
};

// no prefetching

// no preloaded

var currentUpdatedModulesList;
var waitingUpdateResolves = {};
function loadUpdateChunk(chunkId, updatedModulesList) {
	currentUpdatedModulesList = updatedModulesList;
	return new Promise((resolve, reject) => {
		waitingUpdateResolves[chunkId] = resolve;
		// start update chunk loading
		var url = __webpack_require__.p + __webpack_require__.hu(chunkId);
		// create error before stack unwound to get useful stacktrace later
		var error = new Error();
		var loadingEnded = (event) => {
			if(waitingUpdateResolves[chunkId]) {
				waitingUpdateResolves[chunkId] = undefined
				var errorType = event && (event.type === 'load' ? 'missing' : event.type);
				var realSrc = event && event.target && event.target.src;
				error.message = 'Loading hot update chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
				error.name = 'ChunkLoadError';
				error.type = errorType;
				error.request = realSrc;
				reject(error);
			}
		};
		__webpack_require__.l(url, loadingEnded);
	});
}

globalThis["webpackHotUpdatedashboard"] = (chunkId, moreModules, runtime) => {
	for(var moduleId in moreModules) {
		if(__webpack_require__.o(moreModules, moduleId)) {
			currentUpdate[moduleId] = moreModules[moduleId];
			if(currentUpdatedModulesList) currentUpdatedModulesList.push(moduleId);
		}
	}
	if(runtime) currentUpdateRuntime.push(runtime);
	if(waitingUpdateResolves[chunkId]) {
		waitingUpdateResolves[chunkId]();
		waitingUpdateResolves[chunkId] = undefined;
	}
};

    var currentUpdateChunks, currentUpdate, currentUpdateRemovedChunks, currentUpdateRuntime;
    function applyHandler(options) {
      if (__webpack_require__.f)
        delete __webpack_require__.f.jsonpHmr;
      currentUpdateChunks = void 0;
      function getAffectedModuleEffects(updateModuleId) {
        var outdatedModules = [updateModuleId], outdatedDependencies = {}, queue = outdatedModules.map(function(id) {
          return {
            chain: [id],
            id
          };
        });
        while (queue.length > 0) {
          var queueItem = queue.pop(), moduleId = queueItem.id, chain = queueItem.chain, module = __webpack_require__.c[moduleId];
          if (!module || module.hot._selfAccepted && !module.hot._selfInvalidated)
            continue;
          if (module.hot._selfDeclined)
            return {
              type: "self-declined",
              chain,
              moduleId
            };
          if (module.hot._main)
            return {
              type: "unaccepted",
              chain,
              moduleId
            };
          for (var i = 0;i < module.parents.length; i++) {
            var parentId = module.parents[i], parent = __webpack_require__.c[parentId];
            if (!parent)
              continue;
            if (parent.hot._declinedDependencies[moduleId])
              return {
                type: "declined",
                chain: chain.concat([parentId]),
                moduleId,
                parentId
              };
            if (outdatedModules.indexOf(parentId) !== -1)
              continue;
            if (parent.hot._acceptedDependencies[moduleId]) {
              if (!outdatedDependencies[parentId])
                outdatedDependencies[parentId] = [];
              addAllToSet(outdatedDependencies[parentId], [moduleId]);
              continue;
            }
            delete outdatedDependencies[parentId];
            outdatedModules.push(parentId);
            queue.push({
              chain: chain.concat([parentId]),
              id: parentId
            });
          }
        }
        return {
          type: "accepted",
          moduleId: updateModuleId,
          outdatedModules,
          outdatedDependencies
        };
      }
      function addAllToSet(a, b) {
        for (var i = 0;i < b.length; i++) {
          var item = b[i];
          if (a.indexOf(item) === -1)
            a.push(item);
        }
      }
      var outdatedDependencies = {}, outdatedModules = [], appliedUpdate = {}, warnUnexpectedRequire = function warnUnexpectedRequire(module) {
        console.warn("[HMR] unexpected require(" + module.id + ") to disposed module");
      };
      for (var moduleId in currentUpdate)
        if (__webpack_require__.o(currentUpdate, moduleId)) {
          var newModuleFactory = currentUpdate[moduleId], result = newModuleFactory ? getAffectedModuleEffects(moduleId) : {
            type: "disposed",
            moduleId
          }, abortError = !1, doApply = !1, doDispose = !1, chainInfo = "";
          if (result.chain)
            chainInfo = `
Update propagation: ` + result.chain.join(" -> ");
          switch (result.type) {
            case "self-declined":
              if (options.onDeclined)
                options.onDeclined(result);
              if (!options.ignoreDeclined)
                abortError = Error("Aborted because of self decline: " + result.moduleId + chainInfo);
              break;
            case "declined":
              if (options.onDeclined)
                options.onDeclined(result);
              if (!options.ignoreDeclined)
                abortError = Error("Aborted because of declined dependency: " + result.moduleId + " in " + result.parentId + chainInfo);
              break;
            case "unaccepted":
              if (options.onUnaccepted)
                options.onUnaccepted(result);
              if (!options.ignoreUnaccepted)
                abortError = Error("Aborted because " + moduleId + " is not accepted" + chainInfo);
              break;
            case "accepted":
              if (options.onAccepted)
                options.onAccepted(result);
              doApply = !0;
              break;
            case "disposed":
              if (options.onDisposed)
                options.onDisposed(result);
              doDispose = !0;
              break;
            default:
              throw Error("Unexception type " + result.type);
          }
          if (abortError)
            return {
              error: abortError
            };
          if (doApply) {
            appliedUpdate[moduleId] = newModuleFactory;
            addAllToSet(outdatedModules, result.outdatedModules);
            for (moduleId in result.outdatedDependencies)
              if (__webpack_require__.o(result.outdatedDependencies, moduleId)) {
                if (!outdatedDependencies[moduleId])
                  outdatedDependencies[moduleId] = [];
                addAllToSet(outdatedDependencies[moduleId], result.outdatedDependencies[moduleId]);
              }
          }
          if (doDispose) {
            addAllToSet(outdatedModules, [result.moduleId]);
            appliedUpdate[moduleId] = warnUnexpectedRequire;
          }
        }
      currentUpdate = void 0;
      var outdatedSelfAcceptedModules = [];
      for (var j = 0;j < outdatedModules.length; j++) {
        var outdatedModuleId = outdatedModules[j], module = __webpack_require__.c[outdatedModuleId];
        if (module && (module.hot._selfAccepted || module.hot._main) && appliedUpdate[outdatedModuleId] !== warnUnexpectedRequire && !module.hot._selfInvalidated)
          outdatedSelfAcceptedModules.push({
            module: outdatedModuleId,
            require: module.hot._requireSelf,
            errorHandler: module.hot._selfAccepted
          });
      }
      var moduleOutdatedDependencies;
      return {
        dispose: function() {
          currentUpdateRemovedChunks.forEach(function(chunkId) {
            delete installedChunks[chunkId];
          });
          currentUpdateRemovedChunks = void 0;
          var idx, queue = outdatedModules.slice();
          while (queue.length > 0) {
            var moduleId = queue.pop(), module = __webpack_require__.c[moduleId];
            if (!module)
              continue;
            var data = {}, disposeHandlers = module.hot._disposeHandlers;
            for (j = 0;j < disposeHandlers.length; j++)
              disposeHandlers[j].call(null, data);
            __webpack_require__.hmrD[moduleId] = data;
            module.hot.active = !1;
            delete __webpack_require__.c[moduleId];
            delete outdatedDependencies[moduleId];
            for (j = 0;j < module.children.length; j++) {
              var child = __webpack_require__.c[module.children[j]];
              if (!child)
                continue;
              idx = child.parents.indexOf(moduleId);
              if (idx >= 0)
                child.parents.splice(idx, 1);
            }
          }
          var dependency;
          for (var outdatedModuleId in outdatedDependencies)
            if (__webpack_require__.o(outdatedDependencies, outdatedModuleId)) {
              module = __webpack_require__.c[outdatedModuleId];
              if (module) {
                moduleOutdatedDependencies = outdatedDependencies[outdatedModuleId];
                for (j = 0;j < moduleOutdatedDependencies.length; j++) {
                  dependency = moduleOutdatedDependencies[j];
                  idx = module.children.indexOf(dependency);
                  if (idx >= 0)
                    module.children.splice(idx, 1);
                }
              }
            }
        },
        apply: function(reportError) {
          for (var updateModuleId in appliedUpdate)
            if (__webpack_require__.o(appliedUpdate, updateModuleId))
              __webpack_require__.m[updateModuleId] = appliedUpdate[updateModuleId];
          for (var i = 0;i < currentUpdateRuntime.length; i++)
            currentUpdateRuntime[i](__webpack_require__);
          for (var outdatedModuleId in outdatedDependencies)
            if (__webpack_require__.o(outdatedDependencies, outdatedModuleId)) {
              var module = __webpack_require__.c[outdatedModuleId];
              if (module) {
                moduleOutdatedDependencies = outdatedDependencies[outdatedModuleId];
                var callbacks = [], errorHandlers = [], dependenciesForCallbacks = [];
                for (var j = 0;j < moduleOutdatedDependencies.length; j++) {
                  var dependency = moduleOutdatedDependencies[j], acceptCallback = module.hot._acceptedDependencies[dependency], errorHandler = module.hot._acceptedErrorHandlers[dependency];
                  if (acceptCallback) {
                    if (callbacks.indexOf(acceptCallback) !== -1)
                      continue;
                    callbacks.push(acceptCallback);
                    errorHandlers.push(errorHandler);
                    dependenciesForCallbacks.push(dependency);
                  }
                }
                for (var k = 0;k < callbacks.length; k++)
                  try {
                    callbacks[k].call(null, moduleOutdatedDependencies);
                  } catch (err) {
                    if (typeof errorHandlers[k] === "function")
                      try {
                        errorHandlers[k](err, {
                          moduleId: outdatedModuleId,
                          dependencyId: dependenciesForCallbacks[k]
                        });
                      } catch (err2) {
                        if (options.onErrored)
                          options.onErrored({
                            type: "accept-error-handler-errored",
                            moduleId: outdatedModuleId,
                            dependencyId: dependenciesForCallbacks[k],
                            error: err2,
                            originalError: err
                          });
                        if (!options.ignoreErrored) {
                          reportError(err2);
                          reportError(err);
                        }
                      }
                    else {
                      if (options.onErrored)
                        options.onErrored({
                          type: "accept-errored",
                          moduleId: outdatedModuleId,
                          dependencyId: dependenciesForCallbacks[k],
                          error: err
                        });
                      if (!options.ignoreErrored)
                        reportError(err);
                    }
                  }
              }
            }
          for (var o = 0;o < outdatedSelfAcceptedModules.length; o++) {
            var item = outdatedSelfAcceptedModules[o], moduleId = item.module;
            try {
              item.require(moduleId);
            } catch (err) {
              if (typeof item.errorHandler === "function")
                try {
                  item.errorHandler(err, {
                    moduleId,
                    module: __webpack_require__.c[moduleId]
                  });
                } catch (err1) {
                  if (options.onErrored)
                    options.onErrored({
                      type: "self-accept-error-handler-errored",
                      moduleId,
                      error: err1,
                      originalError: err
                    });
                  if (!options.ignoreErrored) {
                    reportError(err1);
                    reportError(err);
                  }
                }
              else {
                if (options.onErrored)
                  options.onErrored({
                    type: "self-accept-errored",
                    moduleId,
                    error: err
                  });
                if (!options.ignoreErrored)
                  reportError(err);
              }
            }
          }
          return outdatedModules;
        }
      };
    }
    __webpack_require__.hmrI.jsonp = function(moduleId, applyHandlers) {
      if (!currentUpdate) {
        currentUpdate = {};
        currentUpdateRuntime = [];
        currentUpdateRemovedChunks = [];
        applyHandlers.push(applyHandler);
      }
      if (!__webpack_require__.o(currentUpdate, moduleId))
        currentUpdate[moduleId] = __webpack_require__.m[moduleId];
    };
    __webpack_require__.hmrC.jsonp = function(chunkIds, removedChunks, removedModules, promises, applyHandlers, updatedModulesList) {
      applyHandlers.push(applyHandler);
      currentUpdateChunks = {};
      currentUpdateRemovedChunks = removedChunks;
      currentUpdate = removedModules.reduce(function(obj, key) {
        obj[key] = !1;
        return obj;
      }, {});
      currentUpdateRuntime = [];
      chunkIds.forEach(function(chunkId) {
        if (__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId] !== void 0) {
          promises.push(loadUpdateChunk(chunkId, updatedModulesList));
          currentUpdateChunks[chunkId] = !0;
        } else
          currentUpdateChunks[chunkId] = !1;
      });
      if (__webpack_require__.f)
        __webpack_require__.f.jsonpHmr = function(chunkId, promises) {
          if (currentUpdateChunks && __webpack_require__.o(currentUpdateChunks, chunkId) && !currentUpdateChunks[chunkId]) {
            promises.push(loadUpdateChunk(chunkId));
            currentUpdateChunks[chunkId] = !0;
          }
        };
    };
  

__webpack_require__.hmrM = () => {
	if (typeof fetch === "undefined") throw new Error("No browser support: need fetch API");
	return fetch(__webpack_require__.p + __webpack_require__.hmrF()).then((response) => {
		if(response.status === 404) return; // no update available
		if(!response.ok) throw new Error("Failed to fetch update manifest " + response.statusText);
		return response.json();
	});
};

// no on chunks loaded

// install a JSONP callback for chunk loading
var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
	var [chunkIds, moreModules, runtime] = data;
	// add "moreModules" to the modules object,
	// then flag all "chunkIds" as loaded and fire callback
	var moduleId, chunkId, i = 0;
	if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
		for(moduleId in moreModules) {
			if(__webpack_require__.o(moreModules, moduleId)) {
				__webpack_require__.m[moduleId] = moreModules[moduleId];
			}
		}
		if(runtime) var result = runtime(__webpack_require__);
	}
	if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
	for(;i < chunkIds.length; i++) {
		chunkId = chunkIds[i];
		if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
			installedChunks[chunkId][0]();
		}
		installedChunks[chunkId] = 0;
	}

}

var chunkLoadingGlobal = globalThis["webpackChunkdashboard"] = globalThis["webpackChunkdashboard"] || [];
chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));